import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Subject } from 'rxjs';

@Injectable()
export class ApiService {
  private _reloadRequested = new Subject<string>();
  private _postOrPutRequested = new Subject<string>();
  private _getRequest = new Subject<string>();
  public reloadRequested = this._reloadRequested.asObservable();
  public postOrPutRequested = this._postOrPutRequested.asObservable();

  constructor(
    private _http: HttpClient
  ) {
  }

  post(data: any, resource: string) {

    return this._http.post(resource, data);
  }

  put(data: any, resource: string) {

    this._postOrPutRequested.next();
    return this._http.put(resource, data);
  }

  delete(resource: string) {

    this._postOrPutRequested.next();
    return this._http.delete(resource);
  }

  public get(resource: string) {
    this._getRequest.next();
    return this._http.get(resource);
  }

  public reload(list: string) {
    this._reloadRequested.next(list);
  }

}
